import { Component, OnInit } from '@angular/core';
import { User } from '@cradua/domain';
import { AuthenticationService } from '../../services/auth.service';

@Component({
  selector: 'mrsoftapps-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardHomeComponent implements OnInit {
 user: User;
  constructor(private authServ: AuthenticationService) { }

  ngOnInit() {
    this.user = this.authServ.getUser();
  }

}
